import React from 'react';
import { ConnectedRouter } from 'connected-react-router';
import { Switch, Route, Redirect } from 'react-router-dom';
import { isDev, isLocal } from 'stash/utils';
import { lazyLoad } from 'stash/utils/lazy';

const AsyncUniversalOnboardingApp = lazyLoad(() =>
	import('stash/apps/onboarding/UniversalOnboardingAppWithGraphql')
);

const AsyncPageNotFound404 = lazyLoad(() =>
	import('stash/components/screens/404-page/PageNotFound404')
);

const AsyncSignUpDevTool = lazyLoad(() =>
	import('stash/components/screens/dev/SignUpDevTool')
);

const AsyncLinkPlaidOAuth = lazyLoad(() =>
	import('stash/components/screens/payment-source/plaidv2/LinkPlaidOAuth')
);

const AsyncInternalAuthPage = lazyLoad(() =>
	import('stash/components/screens/authorize/Authorize')
);

const AsyncSmartPortfolioReconfirmationScreen = lazyLoad(() =>
	import(
		'stash/components/screens/smart-portfolio-reconfirmation-screen/SmartPortfolioReconfirmationScreen'
	)
);

const AsyncIntent = lazyLoad(() => import('stash/components/screens/intent/Intent'));

const AsyncPublicWelcomeCarousel = lazyLoad(() =>
	import(
		'stash/components/screens/public-welcome-carousel/PublicWelcomeCarouselContainer'
	)
);

export const Routes = ({ history }) => {
	return (
		<ConnectedRouter history={history}>
			<Switch>
				<Redirect from="/web/*" to="/*" />
				<Redirect
					exact
					from="/"
					to={{ search: window.location.search, pathname: '/sign-up/get-started' }}
				/>
				<Redirect
					exact
					from="/sign-up"
					to={{ search: window.location.search, pathname: '/sign-up/get-started' }}
				/>
				<Redirect
					exact
					from="/sign-up-purchase"
					to={{
						search: window.location.search,
						pathname: '/sign-up-purchase/get-started',
					}}
				/>
				<Redirect
					exact
					from="/sign-up-retire"
					to={{ search: window.location.search, pathname: '/sign-up-retire/get-started' }}
				/>
				<Route
					exact
					path="/sign-up/set-schedule/reconfirm-smart-success"
					component={AsyncSmartPortfolioReconfirmationScreen}
				/>
				{isLocal() && <Route path="/authorize" component={AsyncInternalAuthPage} />}
				<Route path="/oauth/plaid/*" component={AsyncLinkPlaidOAuth} />
				<Route
					path="/sign-up-:product/get-started"
					component={AsyncUniversalOnboardingApp}
				/>
				<Route path="/sign-up/intent" component={AsyncIntent} />
				<Route path="/sign-up/get-started" component={AsyncUniversalOnboardingApp} />
				<Route path="/sign-up/welcome" component={AsyncPublicWelcomeCarousel} />
				<Route strict path="/sign-up-:product/" component={AsyncUniversalOnboardingApp} />
				<Route strict path="/sign-up/" component={AsyncUniversalOnboardingApp} />
				{isDev() && <Route path="/dev/sign-up" component={AsyncSignUpDevTool} />}
				<Route path="*" component={AsyncPageNotFound404} />
			</Switch>
		</ConnectedRouter>
	);
};

export default Routes;
